import classNames from 'classnames';

import { isColorBright, resolveColorProperty } from '@gn-audio/jss-components';

import { Column } from './tableSpotTypes';

const HeaderCell = ({
  column: { title, width, hideTitleOnMobile, backgroundEvenCells },
}: {
  column: Column;
}) => {
  const background = backgroundEvenCells?.value;
  const backgroundHex = resolveColorProperty(background || 'white');
  const textColorClass = isColorBright(backgroundHex) ? 'text-black' : 'text-white';
  return (
    <th
      className={`border border-b-0 border-gray-200 p-3 text-start text-lg font-bold md:p-5 md:text-2xl ${textColorClass}`}
      style={{ backgroundColor: backgroundHex, width: width?.value || 'auto' }}
    >
      <span
        className={classNames({ 'sr-only md:not-sr-only': hideTitleOnMobile?.value })}
        dangerouslySetInnerHTML={{ __html: title?.value || '' }}
      />
    </th>
  );
};
export default HeaderCell;
